import { render, staticRenderFns } from "./header-preview.vue?vue&type=template&id=15284afc&scoped=true&"
import script from "./header-preview.vue?vue&type=script&lang=js&"
export * from "./header-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15284afc",
  null
  
)

export default component.exports